// Centralised story-generation step metadata, ported from the duplicated
// STEPS arrays in stories.js and story_progress.js.

export type StoryStatus =
  | 'pending'
  | 'writing'
  | 'structuring'
  | 'generating_images'
  | 'composing_scenes'
  | 'complete'
  | 'failed';

export const IN_PROGRESS_STATUSES: StoryStatus[] = [
  'pending',
  'writing',
  'structuring',
  'generating_images',
  'composing_scenes',
];

type Step = { key: StoryStatus; pct: number };

const STEPS: Step[] = [
  { key: 'pending', pct: 0 },
  { key: 'writing', pct: 15 },
  { key: 'structuring', pct: 35 },
  { key: 'generating_images', pct: 55 },
  { key: 'composing_scenes', pct: 80 },
  { key: 'complete', pct: 100 },
];

export function getStepPct(status: string): number {
  return STEPS.find((s) => s.key === status)?.pct ?? 0;
}

/** Returns an i18n key (resolve with useTranslation's t()). */
export function getStepLabelKey(status: string): string {
  const found = STEPS.find((s) => s.key === status);
  return found ? `storyStatus.${found.key}` : status;
}

export function isInProgress(status: string): boolean {
  return (IN_PROGRESS_STATUSES as string[]).includes(status);
}
